export default __webpack_public_path__ + "static/media/wallet.018ad3c0.svg";